<div class="notes-section">
  <div class="notes-container">
    <div class="notes-header">
      <h1 class="notes-title" data-translation-key="horse_info_horse_note">
        {{ 'horse_info.horse_note' | translate }}
      </h1>
    </div>
    @if (isAddedSucessfully) {
      <div
        class="notes-added my-2"
        data-translation-key="horse_info_see_notes_later"
        >
        {{ 'horse_info.see_notes_later' | translate }}
      </div>
    }
    <div class="notes-content">
      <!-- Dynamic Note Fields -->
      @for (field of noteFields; track trackByFieldId($index, field)) {
        <div
          class="notes-row"
          [attr.data-field-id]="field.id"
          >
          <span
            class="notes-label"
            [attr.data-translation-key]="field.translationDataKey"
            >{{ field.label }}</span
            >
            <div
              class="notes-value d-flex flex-row-reverse gap-4 flex-wrap-reverse"
              >
              <!-- Display existing values -->
              @if (hasFieldValueFromAPI(field.id)) {
                <div
                  class="field-display"
                  >
                  <!-- Single selection display (like rating) -->
                  @if (field.type === 'single') {
                    <div class="rating-display">
                      <mat-icon class="star-icon">star</mat-icon>
                      <span class="rating-text">
                        {{
                        hasFieldValue(field.id)
                        ? getFieldDisplayValue(field.id)
                        : getFieldDisplayValueFromAPI(field.id)
                        }}
                      </span>
                    </div>
                  }
                  <!-- Multiple selection display (like conformation, scope) -->
                  @if (field.type === 'multiple') {
                    <div class="selected-items">
                      @for (
                        label of getDisplayLabels(field.id); track
                        label; let last = $last) {
                        <span
                          class="selected-chip"
                          >
                          {{ label }}@if (!last) {
                          <span>, </span>
                        }
                      </span>
                    }
                  </div>
                }
                @if (field.type !== 'text' && hasFieldValueFromAPI(field.id)) {
                  <button
                    mat-icon-button
                    class="edit-button"
                    (click)="toggleDropdown(field.id, $event)"
                    [disabled]="isFieldSaving(field.id)"
                    >
                    @if (isFieldSaving(field.id)) {
                      <mat-spinner
                        [diameter]="20"
                      ></mat-spinner>
                    }
                    @if (!isFieldSaving(field.id)) {
                      <img
                        src="assets/images/edit.svg"
                        alt="edit"
                        />
                    }
                  </button>
                }
                <!-- Text display - FIXED SECTION -->
                @if (field.type === 'text') {
                  <div class="notes-text">
                    @if (!dropdownStates[field.id]?.isOpen) {
                      <button
                        mat-raised-button
                        class="action-button primary-btn"
                        (click)="toggleTextNotePanel(field.id)"
                        >
                        <i class="bi bi-eye"></i>
                        {{
                        isTextNotePanel
                        ? ('horse_info.hide_note' | translate)
                        : ('horse_info.show_note' | translate)
                        }}
                      </button>
                    }
                    <!-- Show Done button when editing -->
                    @if (dropdownStates[field.id]?.isOpen) {
                      <button
                        class="action-button btn btn-primary d-flex justify-content-center save-btn"
                        (click)="saveHorseNote(field.id)"
                        data-translation-key="horse_info_save"
                        [disabled]="isDoneButtonDisabled"
                        >
                        @if (isFieldSaving(field.id)) {
                          <mat-spinner
                            [diameter]="20"
                          ></mat-spinner>
                        }
                        {{
                        !isFieldSaving(field.id) ? ('horse_info.save' | translate) : ""
                        }}
                      </button>
                    }
                  </div>
                }
              </div>
            } @else {
              <!-- Write Note button for text fields -->
              @if (field.type === 'text' && !dropdownStates[field.id]?.isOpen) {
                <button
                  mat-raised-button
                  class="action-button btn btn-primary"
                  (click)="toggleDropdown(field.id, $event)"
                  [attr.data-translation-key]="field.buttonTextTranslationDataKey"
                  [disabled]="isFieldSaving(field.id)"
                  >
                  @if (isFieldSaving(field.id)) {
                    <mat-spinner
                      [diameter]="20"
                    ></mat-spinner>
                  }
                  {{ !isFieldSaving(field.id) ? field.buttonText : "" }}
                </button>
              }
              <!-- Done button for text fields when editing -->
              @if (field.type === 'text' && dropdownStates[field.id]?.isOpen) {
                <button
                  class="action-button btn btn-primary d-flex justify-content-center save-btn"
                  (click)="saveHorseNote(field.id)"
                  data-translation-key="horse_info_save"
                  [disabled]="isDoneButtonDisabled"
                  >
                  @if (isFieldSaving(field.id)) {
                    <mat-spinner
                      [diameter]="20"
                    ></mat-spinner>
                  }
                  {{
                  !isFieldSaving(field.id) ? ('horse_info.save' | translate) : ""
                  }}
                </button>
              }
              <!-- Button for non-text fields -->
              @if (field.type !== 'text') {
                <button
                  mat-raised-button
                  class="action-button btn btn-primary"
                  (click)="toggleDropdown(field.id, $event)"
                  [attr.data-translation-key]="field.buttonTextTranslationDataKey"
                  [disabled]="isFieldSaving(field.id)"
                  >
                  @if (isFieldSaving(field.id)) {
                    <mat-spinner
                      [diameter]="20"
                    ></mat-spinner>
                  }
                  {{ !isFieldSaving(field.id) ? field.buttonText : "" }}
                </button>
              }
            }
            @if (field.type === 'text' && dropdownStates[field.id]?.isOpen) {
              <div
                class="selected-items notes-input-container"
                >
                <input
                  [placeholder]="'horse_info.write_note_placeholder' | translate"
                  class="notes-input"
                  [value]="dropdownStates[field.id]?.textValue || ''"
                  (input)="onTextChange(field.id, $any($event.target).value)"
                  />
                </div>
              }
              <!-- Action button for empty fields - FIXED SECTION -->
            </div>
            <!-- Dropdown panel for non-text fields with dynamic positioning -->
            @if (dropdownStates[field.id]?.isOpen && field.type !== 'text') {
              <div
                [class]="getDropdownClasses(field.id)"
                >
                <!-- Options dropdown for single/multiple selection -->
                @if (field.options) {
                  <div class="dropdown-list">
                    @for (option of field.options; track trackByValue($index, option)) {
                      <div
                        class="dropdown-item"
                        (click)="onOptionSelect(field.id, option.value, field)"
                        >
                        <!-- Radio button for single selection -->
                        @if (field.type === 'single') {
                          <mat-radio-group
                            aria-label="Select an option"
                            class="radio w-100"
                            >
                            <mat-radio-button
                              class="option-label"
                              [value]="option.value"
                              [checked]="isFieldSelected(field.id, option.value)"
                              (click)="onOptionSelect(field.id, option.value, field)"
                              >
                              {{ option.label }}
                            </mat-radio-button>
                          </mat-radio-group>
                        }
                        <!-- Checkbox for multiple selection -->
                        @if (field.type === 'multiple') {
                          <mat-checkbox
                            [id]="field.id + '_' + option.value"
                            [checked]="isFieldSelected(field.id, option.value)"
                            (change)="onOptionSelect(field.id, option.value, field)"
                            (click)="$event.stopPropagation()"
                            class="w-100"
                            >
                            <span class="label w-100">{{ option.label }}</span>
                          </mat-checkbox>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <!-- Text note panel for viewing existing notes with dynamic positioning -->
            @if (
              isTextNotePanel &&
              field.type === 'text' &&
              getFieldDisplayValueFromAPI(field.id)
              ) {
              <div
          [class]="
            'dropdown-panel panel-text show dropdown-' +
            (dropdownPositions[field.id] || 'bottom')
          "
                >
                <img
                  (click)="toggleTextNotePanel(field.id)"
                  src="../../../../../../../assets/images/close.svg"
                  alt="close"
                  class="close-note-panel"
                  />
                  <p class="notes-content-text">
                    {{ getFieldDisplayValue(field.id) }}
                  </p>
                  <button
                    mat-icon-button
                    class="edit-button"
                    (click)="toggleDropdown(field.id, $event)"
                    >
                    <img src="assets/images/edit.svg" alt="edit" />
                  </button>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
